export default {
    getCategoriesProdutos: { method: 'get', url: 'product/estrutras//' },
    getProdutosByCategories: { method: 'get', url: 'product/?aplicacao__id={car}&estrutura__id={categorie}' },
    getProdutosByCar: { method: 'get', url: 'product/ByCar//?car={car}' },
    deleteGarage: { method: 'delete', url: 'client/deleteGarage/{id}/' },
  }
  